import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import themePropTypes from "../theme-prop-types";

const defultPillWidth = 80;
const pulsePillWidth = 138;

const defultPillHeight = 40;
const pulsePillHeight = 44;

const timeToString = (time, usePulseStyles) => {
  const dateFormat = usePulseStyles ? "h:mm A" : "h:mma";
  return moment(time, "YYYY-MM-DDTHH:mm:ss").format(dateFormat);
};

const TimePicker = ({
  defaultValue,
  value,
  minTime,
  maxTime,
  onChange,
  invalid,
  components: { Pills },
  step = 30,
  usePulseStyles,
  dateValue,
  excludeTimes,
  appData
}) => {
  const pillWidth = usePulseStyles ? pulsePillWidth : defultPillWidth;
  const pillHeight = usePulseStyles ? pulsePillHeight : defultPillHeight;

  const [internalValue, setInternalValue] = useState(defaultValue);
  const handleChange = time => {
    if (!value) {
      setInternalValue(time);
    }
    onChange(time);
  };

  useEffect(() => {
    setInternalValue(defaultValue);
  }, [defaultValue]);

  const times = [];
  for (
    let time = new Date(minTime);
    time.getTime() < maxTime.getTime();
    time = new Date(time.getTime() + step * 60 * 1000)
  ) {
    times.push(time);
  }

  const disabledTimeIndexes = useMemo(() =>
    times
      .map((time, index) =>
        excludeTimes?.some(extime => moment(time).isSame(extime)) ? index : null
      )
      .filter(i => i !== null)
  );
  const { visit_times_for } = appData.settings.translations;

  return (
    <>
      {dateValue && (
        <div
          className={`time-slot-picker-title-web-sdk ${
            invalid ? "invalid" : ""
          } `}
        >
          {`${visit_times_for} ${dateValue}*`}
        </div>
      )}
      <Pills
        width={pillWidth}
        height={pillHeight}
        options={times.map(time => ({
          value: time.getTime(),
          text: timeToString(time, usePulseStyles)
        }))}
        value={(value || internalValue)?.getTime()}
        onChange={time => handleChange(new Date(time))}
        invalid={invalid}
        disabled={disabledTimeIndexes}
      />
    </>
  );
};

TimePicker.propTypes = themePropTypes.timePicker;

export default TimePicker;
